import React, { useState } from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";

import { testimonialTabs } from "./helper";

const TestimonialTabs = ({ history, match }) => {
	const [activeTab, setActiveTab] = useState(0);

	const renderTabs = () => {
		return (
			testimonialTabs &&
			testimonialTabs.map((step, i) => {
				const SpecificStep = step.component;

				return (
					<Tab key={step.id} eventKey={i} title={step.title}>
						<SpecificStep match={match} setActiveTab={setActiveTab} history={history} />
					</Tab>
				);
			})
		);
	};

	return (
		<Tabs activeKey={activeTab} className="pt-2" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
			{renderTabs()}
		</Tabs>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(TestimonialTabs);
